var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import '@polkadot/api-augment';
import { ApiPromise, WsProvider } from '@polkadot/api';
import { Assets, System, ParachainCrowdloan, NominationPools } from './substrate';
import { MoonbeamCrowdloanRewards } from './moonbeam';
import { tickerPrice } from '../utils';
import { AcalaLPTokens, AcalaTokens } from './acala';
export function makeApi(ws) {
    return __awaiter(this, void 0, void 0, function* () {
        const provider = new WsProvider(ws);
        const api = yield ApiPromise.create({ provider });
        const name = (yield api.rpc.system.chain()).toString();
        // this will cache the price.
        const _price = yield tickerPrice(api.registry.chainTokens[0]);
        return { api, name };
    });
}
export function accountLengthCheck(api, account, expectedLength) {
    try {
        return api.createType('AccountId', account).toU8a().length === expectedLength;
    }
    catch (_a) {
        return false;
    }
}
export function scrape(account, api) {
    return __awaiter(this, void 0, void 0, function* () {
        let assets = [];
        const chain = (yield api.rpc.system.chain()).toString();
        const valueBearingModules = [
            new System(),
            new Assets(),
            new ParachainCrowdloan(),
            new NominationPools(),
            new MoonbeamCrowdloanRewards(),
            new AcalaTokens(),
            new AcalaLPTokens()
        ];
        for (const mod of valueBearingModules) {
            if (mod.identifiers.length === 0) {
                console.log(`❌ module ${JSON.stringify(mod)} has no identifier`);
            }
            // const instances = api.registry.getModuleInstances(api.runtimeVersion.specName.toString(), mod.identifier);
            if (mod.identifiers.every((i) => api.query[i] !== undefined)) {
                try {
                    const moduleAssets = yield mod.extract({ api, name: chain }, account);
                    assets = assets.concat(moduleAssets);
                }
                catch (e) {
                    console.warn(`error while fetching ${mod.identifiers} for ${account} in chain ${chain}:`, e);
                    // throw(e)
                }
            }
        }
        console.log(`✅ fetched ${account} from ${chain}, found ${assets.length} assets.`);
        return assets;
    });
}
